const EXAM_STATUS: any = {
  started: "Started",
  in_progress: "In Progress",
  in_review: "In Review",
  scheduled: "Scheduled",
  report_pending: "Report Pending",
  completed: "Completed",
};

const QUOTE_STATUS: any = {
  quote_sent: "Quotation Received",
  quote_requested: "Quotation Pending",
  denied: "Quotation Denied",
};

const VOUCHER_STATUS: any = {
  claimed: "Claimed",
  created: "Pending",
  cancelled: "Invoked",
  completed: "Voucher Delivered",
  voucher_requested: "Voucher Pending",
  denied: "Voucher Denied",
};

export { EXAM_STATUS, QUOTE_STATUS, VOUCHER_STATUS };
